export default{
  items: [],
  list: [],
  smsLists: [],
  is_active: null,
  listToEdit: {
        group_name: '',
        id_push_moe: '',
        is_active: true,
        updated_at: ''
    }
  }



// WEBPACK FOOTER //
// ./src/store/modules/messageForm/state.js